/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';

/**
 *
 * @export
 * @interface JobInsertDto
 */
export interface JobInsertDto {
    /**
     *
     * @type {string}
     * @memberof JobInsertDto
     */
    workflowId?: string;
    /**
     *
     * @type {string}
     * @memberof JobInsertDto
     */
    status?: string | null;
    /**
     *
     * @type {string}
     * @memberof JobInsertDto
     */
    log?: string | null;
    /**
     *
     * @type {string}
     * @memberof JobInsertDto
     */
    data?: string | null;
    /**
     *
     * @type {string}
     * @memberof JobInsertDto
     */
    runnerId?: string | null;
}

export function JobInsertDtoFromJSON(json: any): JobInsertDto {
    return JobInsertDtoFromJSONTyped(json, false);
}

export function JobInsertDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobInsertDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'workflowId': !exists(json, 'workflowId') ? undefined : json['workflowId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'log': !exists(json, 'log') ? undefined : json['log'],
        'data': !exists(json, 'data') ? undefined : json['data'],
        'runnerId': !exists(json, 'runnerId') ? undefined : json['runnerId'],
    };
}

export function JobInsertDtoToJSON(value?: JobInsertDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'workflowId': value.workflowId,
        'status': value.status,
        'log': value.log,
        'data': value.data,
        'runnerId': value.runnerId,
    };
}

